export const actionTypes = {
  DG_LOADING_START: "DG_LOADING_START",
  DG_LOADING_STOP: "DG_LOADING_STOP",
  DG_SHOW_LIST: "DG_SHOW_LIST",
  DG_ADD_SUCCESS: "DG_ADD_SUCCESS",
  DG_UPDATE_SUCCESS: "DG_UPDATE_SUCCESS",
  DG_DELETE_SOFT: "DG_DELETE_SOFT",
};
